import { olConnectionV1 } from '../../../../../requesters/olConnection';
import {
  getFieldRegionReportWithApplicationStats
} from '../../../../../queries/fieldRegionReportQueryWithApplicationStats';
import { isRegionInsideField } from '../../../../../utils/regionUtils';
import { GraphQlErrorPayload } from './types/GraphQlErrorPayload';

export type FetchRegionReportParams = {
  fieldUUID: string;
  seasonTag: string;
  geometry: unknown;
  onResponse?: (response: unknown) => void;
};

export async function fetchRegionReport({
  fieldUUID,
  seasonTag,
  geometry,
  onResponse,
}: FetchRegionReportParams) {
  const query = getFieldRegionReportWithApplicationStats(
    fieldUUID,
    seasonTag,
    geometry,
  );

  const response = await olConnectionV1(query);
  onResponse?.(response);

  return response?.data?.reports?.fieldRegionReport ?? null;
}

export function validateRegionAgainstField(fieldBoundary: unknown, geometry: unknown) {
  return isRegionInsideField(fieldBoundary, geometry);
}


export const getGraphQlErrorMessage = (error: unknown): string | undefined => {
  const typedError = error as GraphQlErrorPayload;

  return typedError?.response?.errors?.[0]?.message
    || typedError?.errors?.[0]?.message
    || typedError?.response?.data?.errors?.[0]?.message
    || typedError?.message;
};

export const getReportedError = (error: Error, appLocation: string): Error => {
  const graphQlMessage = getGraphQlErrorMessage(error);
  const message = graphQlMessage || error?.message || 'Unknown error';

  return new Error(`${appLocation}: ${message}`);
};
